// extracted by mini-css-extract-plugin
export default {"wrapper":"LPBurgerMenu_wrapper__dU5Ec"};